import { FC, useEffect, useRef, useState } from 'react';
import { SCUIButton, SCUINoRecordComponent, SCUILoadingLinear } from '../../atomic/atoms';
import { SCUIContent } from '../../atomic/organisms';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import { SCUIBreadCrumb, SCUICustomDataGrid, SCUIGeneralDrawer } from '../../atomic/molecules';
import {
    Box,
    Grid,
    FormControl,
    MenuItem,
    Select,
    InputLabel,
    IconButton,
    Menu,
    Tooltip,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import { CargoFeeManagementQuery, CargoManagementQuery } from '../../services/query/';
import { PostCheckoutCommand } from '../../services/command';
import { SCUIMobileDistributionAdd } from './components/SCUIMobileDistributionAdd/SCUIMobileDistributionAdd';
import { SCUIDrawerFilterMobileDistribution } from './components/SCUIDrawerFilterMobileDistribution/SCUIDrawerFilterMobileDistribution';
import cargodistribution from '../../assets/icons/svg/pageIcons/cargodistribution.svg';
import PopupState, { bindMenu, bindTrigger } from 'material-ui-popup-state';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { downloadExcel } from '../../utils/excelFileHelper';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { MFCD, mfcdCls } from './mobileFieldCargoDistribution.classes';

export const MobileFieldCargoDistribution: FC<any> = () => {
    const servisType = 0;

    const { t } = useTranslation();

    const [companyList, setCompanyList] = useState<any>([]);
    const [filterRespData, setFilterRespData] = useState<any>();
    const [cityList, setCityList] = useState<any>([]);
    const [countyList, setCountyList] = useState<any>([]);
    const [companyId, setCompanyId] = useState<any>(-1);
    const [loading, setLoading] = useState(false);
    const [drawerAddOpen, setDrawerAddOpen] = useState(false);
    const [selectedRows, setSelectedRows] = useState<any>();
    const [cityId, setCityId] = useState(0);
    const [countyId, setCountyId] = useState(0);
    const [subCountyId, setSubCountyId] = useState(0);
    const [subCountyList, setSubCountyList] = useState<any>([]);
    const [searchReq, setSearchReq] = useState<any>();
    const [cityName, setCityName] = useState<any>('');
    const [countyName, setCountyName] = useState<any>('');
    const [subCountyName, setSubCountyName] = useState<any>('');
    const [drawerFilterOpen, setDrawerFilterOpen] = useState(false);
    const [dowloandData, setDowloandData] = useState<any>();

    const fileInputRef = useRef<HTMLInputElement>(null!);

    const onDrawerFilterOpen = () => setDrawerFilterOpen(true);
    const onDrawerFilterClose = () => setDrawerFilterOpen(false);

    const handleFileChange = (event: any) => {
        const files = event.target.files;
        if (files && files.length > 0) {
            let file = files[0];
            // Dosya türünü kontrol etmek için örnek bir kod
            if (file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                alert('Lütfen sadece Excel dosyalarını yükleyin.');
                return;
            }
            // if (selectedFile && selectedFile.name === file.name && selectedFile.size === file.size) {
            //   // Aynı dosyayı tekrar seçildiğinde buraya girecek.
            //   UpdateExcelFile(file);
            //   return;
            // }
            UpdateExcelFile(file);
            event.target.value = '';
        }
    };

    useEffect(() => {
        GetCountyList();
    }, [cityId]);

    useEffect(() => {
        GetSubCountyList();
    }, [countyId]);

    useEffect(() => {
        GetCargoCompanyList();
        GetCityList();
    }, []);

    enum ServiceDistributionType {
        'Gelen değer 0' = 0,
        'Günlük Dağıtım' = 1,
        'Mobil Bölge' = 2,
        'Servis Dışı' = 3,
    }

    const GetCargoCompanyList = async () => {
        try {
            CargoFeeManagementQuery.CargoCompanyList().then((res: any) => {
                if (res.data) {
                    let parseData = res.data.map((item: any) => {
                        return {
                            value: item.id,
                            text: item.name,
                        };
                    });
                    setCompanyList(parseData && [...parseData]);
                } else {
                    Swal.fire('Service Error', res.errorMessage, 'error');
                }
            });
        } catch (error: any) {
            Swal.fire('Error', error.toString(), 'error');
        }
    };

    const GetCityList = async () => {
        try {
            let params = {
                addressEntityTypeId: 3,
                countryId: 1,
            };
            CargoManagementQuery.CityList(params).then((res: any) => {
                if (res.data.addressEntities) {
                    let parseData = res.data.addressEntities.map((item: any) => {
                        return {
                            value: item.addressEntityId,
                            text: item.name,
                        };
                    });
                    setCityList(parseData);
                } else {
                    Swal.fire('Service Error', res.errorMessage, 'error');
                }
            });
        } catch (error: any) {
            Swal.fire('Error', error.toString(), 'error');
        }
    };
    const GetCountyList = async () => {
        try {
            let params = {
                ParentAddressEntityId: cityId,
                countryId: 1,
            };
            if (cityId !== 0) {
                CargoManagementQuery.SubAddressEntities(params).then((res: any) => {
                    if (res.data.addressEntities) {
                        let parseData = res.data.addressEntities.map((item: any) => {
                            return {
                                value: item.addressEntityId,
                                text: item.name,
                            };
                        });
                        setCountyList(parseData && [...parseData]);
                    } else {
                        Swal.fire('Service Error', res.errorMessage, 'error');
                    }
                });
            }
        } catch (error: any) {
            Swal.fire('Error', error.toString(), 'error');
        }
    };
    const GetSubCountyList = async () => {
        try {
            let params = {
                ParentAddressEntityId: countyId,
                countryId: 1,
            };
            if (countyId !== 0) {
                CargoManagementQuery.SubAddressEntities(params).then((res: any) => {
                    if (res.data.addressEntities) {
                        let parseData = res.data.addressEntities.map((item: any) => {
                            return {
                                value: item.addressEntityId,
                                text: item.name,
                            };
                        });
                        setSubCountyList(parseData && [...parseData]);
                    } else {
                        Swal.fire('Service Error', res.errorMessage, 'error');
                    }
                });
            }
        } catch (error: any) {
            Swal.fire('Error', error.toString(), 'error');
        }
    };
    const columns: ExtendedGridColDef[] = [
        {
            field: 'cargoCompany',
            headerName: t('cargoFeeManagement.shippingCompanyName'),
            flex: 1,
        },
        {
            field: 'cityName',
            headerName: t('general.cityName'),
            flex: 1,
        },
        {
            field: 'countyName',
            headerName: 'İlçe',
            flex: 1,
        },
        {
            field: 'subCountyName',
            headerName: 'Mahalle',
            flex: 1,
        },
        {
            field: 'serviceDistributionTypeId',
            headerName: 'Servis Tipi',
            flex: 1,
        },
        {
            field: 'weeklyDistributionDays',
            headerName: 'Haftalık Değişim',
            flex: 1,
        },
        {
            field: 'validEndDateForGrid',
            headerName: t('cargoFeeManagement.validEndDate'),
            flex: 1,
            hide: true,
        },
        {
            field: 'detay',
            headerName: 'Detay',
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params: any) => {
                const handleClick = (popupState: any, tur: string) => {
                    popupState.close();
                    switch (tur) {
                        case 'düzenle': {
                            setSelectedRows(params.row);
                            setDrawerAddOpen(true);
                            break;
                        }

                        default: {
                            break;
                        }
                    }
                };
                return (
                    <PopupState variant="popover" popupId="demo-popup-menu">
                        {(popupState: any) => (
                            <Box className={MFCD.datagridActionsCell}>
                                <IconButton
                                    {...bindTrigger(popupState)}
                                    className={mfcdCls('svg_icons', MFCD.inputIconRowActionsMenu)}
                                >
                                    <MoreVertIcon />
                                </IconButton>
                                <Menu
                                    {...bindMenu(popupState)}
                                    slotProps={{ paper: { className: MFCD.rowActionsMenuPaper } }}
                                >
                                    <MenuItem
                                        className={MFCD.inputMenuItemRowEdit}
                                        onClick={() => handleClick(popupState, 'düzenle')}
                                    >
                                        {'Düzenle'}
                                    </MenuItem>
                                </Menu>
                            </Box>
                        )}
                    </PopupState>
                );
            },
        },
    ];
    const handleChangeFilterInput = () => {
        let params = {
            ShippingCompanyId: companyId,
            CityName: cityName.length > 0 ? cityName : null,
            CountyName: countyName.length > 0 ? countyName : null,
            NeighborhoodName: subCountyName.length > 0 ? subCountyName : null,
            ServiceDistributionTypeId: servisType !== 0 ? servisType : null,
        };
        listele(params);
    };

    const onDrawerAddClose = () => setDrawerAddOpen(false);

    const handleDrawerAdd = (value: boolean) => {
        setDrawerAddOpen(value);
        setSelectedRows([]);
    };

    const listele = async (requests?: any) => {
        setLoading(true);
        if (requests && requests !== null) {
            //setLoading(true);
            try {
                let params = {
                    ShippingCompanyId: requests.ShippingCompanyId,
                    CityName: requests.CityName === null || '' ? null : requests.CityName,
                    CountyName: requests.CountyName === null || '' ? null : requests.CountyName,
                    NeighborhoodName: requests.NeighborhoodName === null || '' ? null : requests.NeighborhoodName,
                    ServiceDistributionTypeId:
                        requests.ServiceDistributionTypeId === null || 0 ? null : requests.ServiceDistributionTypeId,
                };
                setSearchReq(params);
                PostCheckoutCommand.GetShippingCompanyServiceDistributionListByShippingCompanyId(params).then(
                    (res: any) => {
                        if (res && res.shippingCompanyServiceDistributionList[0]?.addressEntityId !== 0) {
                            let parseData = res.shippingCompanyServiceDistributionList.map((item: any) => {
                                return {
                                    shippingCompanyId: item.shippingCompanyId || '-',
                                    addressEntityId: item.addressEntityId,
                                    cargoCompany: item.shippingCompanyName,
                                    cityName: item.cityName,
                                    countyName: item.countyName,
                                    subCountyName: item.neighborhoodName,
                                    serviceDistributionTypeId:
                                        ServiceDistributionType[item.serviceDistributionTypeId] || '-',
                                    weeklyDistributionDays: item.weeklyDistributionDays || '-',
                                    cityId: item.cityId,
                                    countyId: item.countyId,
                                    neighborhoodId: item.neighborhoodId,
                                };
                            });
                            let parseData2 = res.shippingCompanyServiceDistributionList.map((item: any) => {
                                return {
                                    shippingCompanyId: item.shippingCompanyId || '-',
                                    addressEntityId: item.addressEntityId,
                                    cargoCompany: item.shippingCompanyName,
                                    cityName: item.cityName,
                                    countyName: item.countyName,
                                    subCountyName: item.neighborhoodName,
                                    weeklyDistributionDays: item.weeklyDistributionDays || '-',
                                };
                            });
                            setFilterRespData(parseData);
                            setDowloandData(parseData2);
                            setLoading(false);
                        } else {
                            Swal.fire(t('general.noDataFound'), res.errorMessage, 'error');
                        }
                    }
                );
            } catch (error: any) {
                Swal.fire('Error', error.toString(), 'error');
            }
        }
    };
    const handleDownload = () => {
        // Example data
        const data = [
            {
                WeeklyDistributionDays: 5,
                CityName: 'Afyonkarahisar',
                CountyName: 'İHSANİYE',
                NeighborhoodName: 'BELCE',
            },
            {
                WeeklyDistributionDays: 5,
                CityName: 'Afyonkarahisar',
                CountyName: 'ÇOBANLAR',
                NeighborhoodName: 'YAVUZ SELİM',
            },
        ];
        downloadExcel({
            excelDownloadData: data,
            excelDownloadFolderName: 'Example',
        });
    };
    const UpdateExcelFile = (data: any) => {
        let bodyFormData = new FormData();
        bodyFormData.append('ShippingCompanyId', companyId);
        bodyFormData.append('Excel', data);
        PostCheckoutCommand.UpsertShippingCompanyServiceDistributionFromExcel(bodyFormData)
            .then((res: any) => {
                if (res.isSuccess === true) {
                    Swal.fire(t('general.updated'), ' ', 'success');
                    listele(searchReq);
                } else {
                    Swal.fire(res.message, ' ', 'error');
                }
            })
            .finally(() => {});
    };

    const handleClickFile = () => {
        // Dosya seçimini tetikle
        fileInputRef.current.click();
    };
    return (
        <SCUIContent>
            <SCUIGeneralDrawer open={drawerFilterOpen} width={'360px'}>
                <SCUIDrawerFilterMobileDistribution
                    onClose={onDrawerFilterClose}
                    companyList={companyList}
                    cityList={cityList}
                    listele={listele}
                />
            </SCUIGeneralDrawer>
            <SCUIGeneralDrawer
                open={drawerAddOpen}
                width={'360px'}
                onClose={(event: any, reason: any) => {
                    if (reason === 'backdropClick') {
                        setDrawerAddOpen(false);
                    }
                }}
            >
                <SCUIMobileDistributionAdd
                    onClose={onDrawerAddClose}
                    companyList={companyList}
                    cityList={cityList}
                    selectedRow={selectedRows}
                    listele={listele}
                    searchReq={searchReq}
                />
            </SCUIGeneralDrawer>
            <Grid
                className={MFCD.page}
                size={{
                    sm: 12,
                    md: 12,
                    lg: 12,
                    xl: 12,
                }}
            >
                <Grid
                    className={MFCD.breadcrumbSection}
                    container
                    direction="row"
                    spacing={2}
                    sx={{ marginLeft: '0.5rem' }}
                >
                    <SCUIBreadCrumb
                        title={'Kargo Firması Hizmet Alanı'}
                        componentLink={'/mobileFieldCargoDistribution'}
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                            window.location.reload();
                        }}
                    />
                    <SCUILoadingLinear display={loading} />
                </Grid>

                <Grid
                    className={MFCD.contentSection}
                    size={{
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    }}
                >
                    {filterRespData && (
                        <Grid
                            className={MFCD.toolbarFiltered}
                            style={{ direction: 'rtl', display: 'flex', gap: '1rem' }}
                            size={{
                                lg: 12,
                                md: 12,
                                xs: 12,
                            }}
                        >
                            <div className={MFCD.toolbarExcelGroup}>
                                <Tooltip title="Örnek Excel İndir">
                                    <InfoOutlinedIcon
                                        className={mfcdCls('cursorPointer', MFCD.inputIconSampleExcelInfo)}
                                        sx={{ color: '016A70', fontSize: 20, marginLeft: '1rem' }}
                                        onClick={handleDownload}
                                    ></InfoOutlinedIcon>
                                </Tooltip>
                                <SCUIButton
                                    className={MFCD.inputButtonExcelUpload}
                                    text="Excel Yükle"
                                    type="primary"
                                    sizeType="fixed"
                                    size={'m'}
                                    showStartIcon
                                    startIcon={<CloudUploadIcon style={{ color: 'white' }} />}
                                    onClick={handleClickFile}
                                    style={{ width: '150px', height: '40px' }}
                                >
                                    <input
                                        type="file"
                                        className={MFCD.excelFileInput}
                                        style={{ display: 'none' }}
                                        ref={fileInputRef}
                                        onChange={handleFileChange}
                                    />
                                </SCUIButton>
                            </div>
                            <Grid
                                className={MFCD.toolbarActionsRow}
                                style={{ direction: 'rtl', display: 'flex', gap: '1rem', marginTop: '1.6rem' }}
                                size={{
                                    lg: 12,
                                    md: 12,
                                    xs: 12,
                                }}
                            >
                                <SCUIButton
                                    className={MFCD.inputButtonAddNew}
                                    style={{ width: '130px', height: '40px' }}
                                    text={'Yeni Ekle'}
                                    type="primary"
                                    sizeType="fixed"
                                    size={'m'}
                                    onClick={() => {
                                        handleDrawerAdd(true);
                                    }}
                                />
                                <Grid
                                    container
                                    justifyContent={'flex-start'}
                                    size={{
                                        sm: 1,
                                        md: 1,
                                        lg: 1,
                                        xl: 1,
                                    }}
                                >
                                    <IconButton
                                        className={mfcdCls('svg_icons', MFCD.inputIconOpenFilterDrawer)}
                                        sx={{
                                            float: 'right',
                                            width: 40,
                                            height: 40,
                                            borderRadius: 2,
                                            border: '1px solid',
                                            borderColor: 'primary.main',
                                            marginRight: 1,
                                            marginTop: -0.3,
                                        }}
                                        onClick={() => onDrawerFilterOpen()}
                                    >
                                        <FilterAltIcon sx={{ color: 'primary.main', fontSize: 18 }} />
                                    </IconButton>
                                </Grid>
                            </Grid>
                        </Grid>
                    )}
                    <Grid
                        className={MFCD.gridSection}
                        size={{
                            sm: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        {filterRespData ? (
                            <Box className={MFCD.gridWrap}>
                                <Grid
                                    size={{
                                        sm: 12,
                                        md: 12,
                                        lg: 12,
                                        xl: 12,
                                    }}
                                >
                                    <SCUICustomDataGrid
                                        randomId
                                        rows={filterRespData}
                                        columns={columns}
                                        excelDownloadButton={true}
                                        excelDownloadButtonName={t('general.exportToExcel')}
                                        excelDownloadData={dowloandData}
                                        excelDownloadFolderName={'MobileFieldDistribution'}
                                    />
                                </Grid>
                            </Box>
                        ) : (
                            <div
                                className={MFCD.emptyGate}
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignContent: 'center',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                            >
                                <SCUINoRecordComponent img={cargodistribution} />

                                <FormControl className={MFCD.emptyGateCompanyField} style={{ width: 450, margin: '20px' }}>
                                    <InputLabel id="labelApp">{t('cargoFeeManagement.selectCargoCompany')}</InputLabel>
                                    <Select
                                        className={MFCD.inputSelectEmptyGateCompany}
                                        label={t('cargoFeeManagement.selectCargoCompany')}
                                        labelId="labelApp"
                                        id="parentMenuLabel"
                                        value={companyId}
                                        onChange={(event) => {
                                            setCompanyId(Number(event.target.value));
                                        }}
                                        fullWidth
                                    >
                                        {companyList &&
                                            companyList.map((comp: any) => (
                                                <MenuItem key={comp.value} id={comp.value} value={comp.value}>
                                                    {comp.text}
                                                </MenuItem>
                                            ))}
                                    </Select>
                                </FormControl>
                                {companyId !== -1 && (
                                    <FormControl className={MFCD.emptyGateCityField} style={{ width: 450, margin: '20px' }}>
                                        <InputLabel id="labelApp">{t('cargoManagement.selectCity')}</InputLabel>
                                        <Select
                                            className={MFCD.inputSelectEmptyGateCity}
                                            label={t('cargoManagement.selectCity')}
                                            labelId="labelApp"
                                            id="parentMenuLabel"
                                            value={cityId}
                                            onChange={(event) => {
                                                setCityId(Number(event.target.value));
                                                setCityName(
                                                    cityList.find((option: any) => option.value === event.target.value)
                                                        ?.text
                                                );
                                            }}
                                            fullWidth
                                        >
                                            {cityList &&
                                                cityList.map((county: any) => (
                                                    <MenuItem key={county.value} id={county.value} value={county.value}>
                                                        {county.text}
                                                    </MenuItem>
                                                ))}
                                        </Select>
                                    </FormControl>
                                )}
                                {cityId !== 0 && (
                                    <FormControl className={MFCD.emptyGateCountyField} style={{ width: 450, margin: '20px' }}>
                                        <InputLabel id="labelApp">{t('cargoManagement.selectCounty')}</InputLabel>
                                        <Select
                                            className={MFCD.inputSelectEmptyGateCounty}
                                            label={t('cargoManagement.selectCounty')}
                                            labelId="labelApp"
                                            id="parentMenuLabel"
                                            value={countyId}
                                            onChange={(event) => {
                                                setCountyId(Number(event.target.value));
                                                setCountyName(
                                                    countyList.find(
                                                        (option: any) => option.value === event.target.value
                                                    )?.text
                                                );
                                            }}
                                            fullWidth
                                        >
                                            {countyList &&
                                                countyList.map((dist: any) => (
                                                    <MenuItem key={dist.value} id={dist.value} value={dist.value}>
                                                        {dist.text}
                                                    </MenuItem>
                                                ))}
                                        </Select>
                                    </FormControl>
                                )}
                                {countyId !== 0 && (
                                    <FormControl
                                        className={MFCD.emptyGateNeighborhoodField}
                                        style={{ width: 450, margin: '20px' }}
                                    >
                                        <InputLabel id="labelApp">{'İlçe Seçiniz'}</InputLabel>
                                        <Select
                                            className={MFCD.inputSelectEmptyGateNeighborhood}
                                            label={'Mahalle Seçiniz'}
                                            labelId="labelApp"
                                            id="parentMenuLabel"
                                            value={subCountyId}
                                            onChange={(event) => {
                                                setSubCountyId(Number(event.target.value));
                                                setSubCountyName(
                                                    subCountyList.find(
                                                        (option: any) => option.value === event.target.value
                                                    )?.text
                                                );
                                            }}
                                            fullWidth
                                        >
                                            {subCountyList &&
                                                subCountyList.map((dist: any) => (
                                                    <MenuItem key={dist.value} id={dist.value} value={dist.value}>
                                                        {dist.text}
                                                    </MenuItem>
                                                ))}
                                        </Select>
                                    </FormControl>
                                )}
                                <FormControl className={MFCD.emptyGateFilterActions} style={{ width: 450, margin: '10px' }}>
                                    <SCUIButton
                                        className={MFCD.inputButtonEmptyGateFilter}
                                        text={t('general.filter')}
                                        type="primary"
                                        sizeType="default"
                                        size={'l'}
                                        onClick={() => {
                                            handleChangeFilterInput();
                                            setLoading(true);
                                        }}
                                    />
                                </FormControl>
                            </div>
                        )}
                    </Grid>
                </Grid>
            </Grid>
        </SCUIContent>
    );
};
